import { render, staticRenderFns } from "./Chapter2_2.vue?vue&type=template&id=252452e5&scoped=true&"
import script from "./Chapter2_2.vue?vue&type=script&lang=js&"
export * from "./Chapter2_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252452e5",
  null
  
)

export default component.exports